export const stripHostname = (url: string): string => {
	try {
		return new URL(url).pathname;
	} catch {
		return '';
	}
};
